import React, { useEffect, useState } from "react";

import "../../VerifyMobile/verifyMobileEmail.css";
import "../EmailOtp/EnterEmailOtp.css";

import axios from "../../../../axios";
import VerifyMobileEmail from "../../VerifyMobile/VerifyMobileEmail";

export default function EnterEmailOtp({
  registerState,
  setIsMobileValidated,
  setVerifyMobile,
}) {
  const [verify] = useState();
  const [otpValue, setOtpValue] = useState("");
  const [isVailidatedMobile, setIsValidatedMobile] = useState({});
  const [continuebnt, setContinuebtn] = useState(true);
  const contactNo = JSON.parse(localStorage.getItem("Mobile_no"));
  //  timer otp js
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(45);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seconds, minutes]);

  const resendOTP = async () => {
    try {
      await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
        mobile_number: contactNo,
      });
      setMinutes(0);
      setSeconds(45);
      setOtpValue("");
      setIsValidatedMobile("");
    } catch (error) {}
  };

  // verify otp
  const handleOtpChange = (value) => {
    const newValue = value.replace(/[^0-9]/g, ""); // Remove any non-digit characters, including the dot
    setOtpValue(newValue);
  };

  useEffect(() => {
    /^\d{6}$/.test(otpValue) ? setContinuebtn(false) : setContinuebtn(true);
    if (otpValue === "") {
      setIsValidatedMobile("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpValue]);

  useEffect(() => {
    if (seconds === 0) {
      setIsValidatedMobile("");
      setOtpValue("");
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [seconds]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (/^\d{6}$/.test(otpValue)) {
      try {
        const res = await axios.post(`/api/v1/teacherAuth/validateMobileOtp`, {
          mobile_otp: otpValue,
          mobile_number: contactNo,
        });
        console.log(otpValue);
        res && setIsValidatedMobile(res.data);
        setIsMobileValidated(res.data.status);
        setVerifyMobile(false);
      } catch (error) {
        setIsValidatedMobile(error.response.data);
      }
    }
  };
  const formattedNumber =
    "+91 - " +
    registerState.contactN
      .toString()
      .replace(/(\d{4})(\d{4})(\d{2})/, "$1 $2 $3");
  return (
    <div className="TotalContainer">
      <div className="MainContainer  p-0  d-md-flex ">
        <div className="banner_box col-md-3 col-12 p-0">
          <img
            className="banner_img "
            src="/Register-img/baner_img.jpg"
            alt="banner img"
          ></img>
        </div>

        <div className="form_box_verify col-md-9 col-12 p-0">
          <div>
            <div className="total_logo_regist">
              <img
                className="logo_EmailOtp"
                src="/Register-img/Register_logo.png"
                alt="register logo"
              ></img>
            </div>
            <div className="title_regis">Enter OTP</div>
            <div className="otpMail">OTP sent to {formattedNumber}</div>
            {/* <div className='otpMail'>OTP sent to kaka</div> */}

            <form>
              <div className="">
                <div>
                  <div className="input_box_otp ">
                    {seconds === 0 ? (
                      <input
                        id="otp_ip_enter_Email"
                        placeholder="Enter OTP"
                        disabled={true}
                      />
                    ) : (
                      <input
                        id="otp_ip_enter_Email"
                        placeholder="Enter OTP"
                        value={otpValue}
                        onChange={(e) => handleOtpChange(e.target.value)}
                        maxLength={6}
                        pattern="[0-9]*"
                        autocomplete="off"
                      />
                    )}

                    <span className="otp_timer_count">
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between">
                    {isVailidatedMobile.status === false && (
                      <div className="invailidOtp">Invalid OTP entered</div>
                    )}
                    {seconds === 0 && (
                      <div className="invailidOtp">OTP Timed out</div>
                    )}
                  </div>

                  <div>
                    <input
                      id={continuebnt ? "btn_disabled" : "otp_btn"}
                      type="submit"
                      className="col-md-12 col-12 btn btn-primary my-3"
                      value="Continue"
                      disabled={continuebnt}
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="d-flex justify-content-center mt-4">
              <button
                className="Resend_otp_email"
                disabled={seconds > 0 || minutes > 0}
                style={{
                  color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#F77F00",
                }}
                onClick={resendOTP}
              >
                Resend OTP
              </button>
            </div>
          </div>
        </div>
      </div>
      {verify && <VerifyMobileEmail />}
    </div>
  );
}
